import { Button } from '@mui/material';
import React from 'react';
import StyledBox from 'views/rebranded-module/location-module/LocationsViewV2/components/MapPlaceHolderV2/MapPlaceHolderV2.styles';

const MapPlaceHolderV2 = (props) => {
  const { onClick, content } = props;
  return (
    <StyledBox>
      <Button variant="outlined" onClick={onClick}>
        {content.showMap}
      </Button>
    </StyledBox>
  );
};

export { MapPlaceHolderV2 };
